import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getMetadataForPath } from '../config/routeMetadata';

// Component to handle dynamic metadata using React Helmet
const DynamicHead = () => {
  const location = useLocation();
  const [metadata, setMetadata] = useState(getMetadataForPath(location.pathname));

  useEffect(() => {
    const basicMetadata = getMetadataForPath(location.pathname);
    console.log('🔍 Setting metadata for path:', location.pathname, basicMetadata);
    setMetadata(basicMetadata);
  }, [location.pathname]);

  return (
    <Helmet>
      <title>{metadata.title}</title>
      <meta name="description" content={metadata.description} />
      
      {/* Open Graph tags for better social media sharing */}
      <meta property="og:title" content={metadata.title} />
      <meta property="og:description" content={metadata.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
      
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metadata.title} />
      <meta name="twitter:description" content={metadata.description} />
      
      {/* Additional SEO meta tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="SOC Maturity Assessment" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
};

export default DynamicHead; 